<script>
import vDialog from "@/components/_Shared/Dialog";
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  components: {
    vDialog
  }
};
</script>
<template>
    <v-dialog
        :visible="visible"
        :icon="{src: '/static/icon-success-purple.svg', size: '60px'}"
        title="Sua solicitação foi enviada!"
    >
    <template slot="body">
        <p>Nosso time de experiência recebeu sua solicitação <br>
            e vai cuidar com muito carinho <3 </p>
        <p>Fique atento aos seus emails! <br>
            Você irá receber nossa comunicação por lá.<br>Verifique também sua caixa de spam ;)</p>

        <base-flex class="mt-30">
          <div class="btn bg-purple-outline" @click="$emit('close')">FECHAR</div>
        </base-flex>
    </template>
    </v-dialog>
</template>



// WEBPACK FOOTER //
// src/components/Freshdesk/Success/Success.vue